module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isSelect && _vm.isChallenge(_vm.act)) ? _c('div', {
    class: {
      type1: !_vm.showText
    },
    attrs: {
      "id": _vm.index
    },
    on: {
      "click": function($event) {
        return _vm.clickImage($event)
      }
    }
  }, [_c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.getPopupTextElem(_vm.eText))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    class: {
      correct: _vm.isCorrect,
      incorrect: _vm.isInCorrect
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image",
    on: {
      "touchstart": function($event) {
        return _vm.$emit('onTouchStart', _vm.act.image)
      },
      "touchend": function($event) {
        return _vm.$emit('onTouchEnd')
      },
      "touchmove": function($event) {
        return _vm.$emit('onTouchEnd')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.act.image
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showVoice),
      expression: "showVoice"
    }],
    staticClass: "icon-voice",
    on: {
      "click": function($event) {
        return _vm.audioPlay(_vm.act.sounds[0])
      }
    }
  })])])]) : _c('div', {
    class: {
      type1: !_vm.showText
    },
    attrs: {
      "id": _vm.index
    },
    on: {
      "click": function($event) {
        return _vm.childAudioPlay(_vm.act.sounds[0])
      }
    }
  }, [_c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.getPopupTextElem(_vm.eText))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    class: {
      correct: _vm.isCorrect,
      incorrect: _vm.isInCorrect
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image",
    on: {
      "touchstart": function($event) {
        return _vm.$emit('onTouchStart', _vm.act.image)
      },
      "touchend": function($event) {
        return _vm.$emit('onTouchEnd')
      },
      "touchmove": function($event) {
        return _vm.$emit('onTouchEnd')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.act.image
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showVoice),
      expression: "showVoice"
    }],
    staticClass: "icon-voice",
    on: {
      "click": function($event) {
        return _vm.audioPlay(_vm.act.sounds[0])
      }
    }
  })])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-26e9dfc9", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-26e9dfc9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/runmode/A1act.vue
// module id = 610
// module chunks = 1